export const BLUE_GRADIENT = 'linear-gradient(91.02deg, #1515B7 6.2%, #1717F2 57.9%, #03DBC7 120.55%)'
export const PURPLE_GRADIENT = 'linear-gradient(91.64deg, #0000A4 3.05%, #B402F0 101.39%)'
export const RED_GRADIENT = 'linear-gradient(90.71deg, #0000A8 5.42%, #E6474C 108.29%)'

export const ROLL_ANIMATION_WORDS = [
  { title: 'homepage.header.roll.doctor', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.hospital', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.surgeon', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.dentist', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.cardiologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.dermatologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.paediatrician', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.urologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.obstetrician', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.physiotherapist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.clinic', gradient: RED_GRADIENT },
  { title: 'homepage.header.roll.care', gradient: RED_GRADIENT },
  { title: 'homepage.header.roll.pharmacy', gradient: RED_GRADIENT }
]

export const ROLL_ANIMATION_WORDS_DE = [
  { title: 'homepage.header.roll.doctor', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.hospital', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.surgeon', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.dentist', gradient: BLUE_GRADIENT },
  { title: 'homepage.header.roll.cardiologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.dermatologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.paediatrician', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.orthopaedic', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.urologist', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.obstetrician', gradient: PURPLE_GRADIENT },
  { title: 'homepage.header.roll.clinic', gradient: RED_GRADIENT },
  { title: 'homepage.header.roll.care', gradient: RED_GRADIENT },
  { title: 'homepage.header.roll.pharmacy', gradient: RED_GRADIENT }
]
